export const environment = {
  production: true,
  apiUrl: 'https://api.zwiloo.com',
};
